import { ImageExtension } from '../models/image';

export const clutchBadge1Location = 'images/clutch-badge-1';
export const clutchBadge2Location = 'images/clutch-badge-2';
export const clutchBadge3Location = 'images/clutch-badge-3';
export const clutchBadgeExtension = ImageExtension.PNG;
export const clutchBadgeAlt =
  'A badge from Business to Business Rating & Review company Clutch, which reads: Top react native developer Southampton 2023';
export const clutchBadgeURL = 'https://clutch.co/profile/peslo-studios#summary';
